import config from '@config';
import { trackEngagement } from '@utils/engagement/engagementUtils';
import { analytics, logEvent, setUserId, setUserProperties } from '@utils/setup.web';

const AmplitudeHelper = {
  init: () => {
    ///  amplitude.init(config.AMPLITUDE_API_KEY);
  },
  logEvent: (eventName: string, data: any) => {
    logEvent(analytics, eventName, data);
    trackEngagement(data, eventName);
  },
  setUserId: (userID, employerID) => {
    setUserId(analytics, userID.toString());
    setUserProperties(analytics, {
      environment: config.ENVIRONMENT,
      employerId: employerID,
    });
  },
  setLocation: async () => {
    // lat, lng
    // amplitude.setUserProperties({
    //   Latitude: lat,
    //   Longitude: lng,
    // });
  },
  setUserProperties: data => {
    setUserProperties(analytics, data);
  },
  // setCustomAttributes: data => {},
  clearUserProperties: () => {
    setUserId(analytics, '');
    // amplitude.regenerateDeviceId();
    // amplitude.clearUserProperties();
  },
};

function captureUTMs() {
  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');
  const utmCampaign = params.get('utm_campaign');
  const utmContent = params.get('utm_content');
  const utmTerm = params.get('utm_term');

  if (utmSource) {
    AmplitudeHelper.logEvent('utm_captured', {
      utm_source: utmSource,
      utm_medium: utmMedium,
      utm_campaign: utmCampaign,
      utm_content: utmContent,
      utm_term: utmTerm,
    });
  }
}

captureUTMs();

export default AmplitudeHelper;
